var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual-menu-item",class:{
            'visual-menu-item_active': _vm.active
        },style:({
            'color': _vm.color,
            'border-color': _vm.color,
            'font-size': _vm.fontSize+'px'
        }),on:{"click":_vm.click}},[_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }